import { useCallback } from 'react';
import { ClientApi, ToastStateHandler } from '../../api';
import { useContainer } from '../useContainer';
import { useTranslation } from '../useTranslation';

export const useDeleteInvoice = () => {
    const clientApi: ClientApi = useContainer(ClientApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const deleteInvoice = useCallback(
        async (invoiceId: string, onSuccess?: () => void) => {
            const { exec } = clientApi.deleteInvoice({
                params: { id: invoiceId },
                onSuccess: () => {
                    toastHandler.push('success', t('invoice.invoiceDeleteTitle'), t('invoice.invoiceDeleteSuccess'));
                    if (onSuccess) onSuccess();
                },
                onError: () => {
                    toastHandler.push('error', t('invoice.invoiceDeleteTitle'), t('invoice.invoiceDeleteFailed'));
                },
            });

            exec();
        },
        [clientApi, toastHandler, t]
    );

    return { deleteInvoice };
};
